import React from 'react';
import './spinner.css'; // still used for layout

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <img
        src="spinner.svg"
        alt="Loading..."
        className="spinner-img"
      />
      <p>Analyzing audio, please wait...</p>
    </div>
  );
};

export default Spinner;
